<template>
  <div class="attendances">
    <transition name="slide" mode="out-in">
      <router-view :key="$route.path"/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Attendances'
}
</script>
